export default __webpack_public_path__ + "static/media/mutsi.a77f0c08.jpeg";